import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Ticket } from '../../models/entities/ticket';
import { TicketPipe } from '../../pipes/ticket-pipe';
import { TicketService } from '../../services/ticket-service';
import { TicketTypeLovComponent } from '../ticket-type-lov/ticket-type-lov.component';
import { TicketPL } from '../../enums/ticket-pl';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { TicketBatchTicket } from '../../models/entities/ticket-batch-ticket';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';

@Component({
    selector: 'ticket-widget',
    templateUrl: './ticket-widget.component.html',
    styleUrls: ['./ticket-widget.component.scss']
})

export class TicketWidgetComponent extends BaseWidget {
  
  ticket            : Ticket = new Ticket();

  ticketTypeLovComponent  = TicketTypeLovComponent;
  ticketPL                = TicketPL;

  priorityLov = [
    {name : 'Faible', priority : 1},
    {name : 'Normal', priority : 2},
    {name : 'Haute',  priority : 3}
  ];

 //---------------------------------------------------------------------------------------
  constructor(
      protected toastr               : ToastrService,
      public    leanUtilsService     : LeanUtilsService,
      protected salesReportsService  : SalesReportsService,
      protected ticketService        : TicketService) {
      super(toastr, leanUtilsService);

      this.entityName = "ticket";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(ticket: Ticket) {
      this.ticket  = { ...ticket };
}
//---------------------------------------------------------------------------------------

  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.ticket;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(): Promise<Ticket> {
  if (this.ticket.inserted) {
    this.ticket.progressLevel = TicketPL.pl_qualified;
    this.ticket.qualificationComment = this.ticket.creationComment;
  }
  if (! this.checkData()) return;
  return this.ticketService.ticketSave(this.ticket, this.requestService);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
qualifyTicket(){
  this.ticket.progressLevel = TicketPL.pl_qualified;
  this.ticket.updated = true;
  this.ticket.edit    = true;
  this.requestService = "qualify";
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeTicket(){
  this.ticket.closingDate = new Date();
  this.ticket.progressLevel = TicketPL.pl_closed;
  this.ticket.updated = true;
  this.ticket.edit    = true;
  this.requestService = "close";
}
//----------------------------------------------------------------------


//---------------------------------------------------------------------------------------
ticketPipe  : TicketPipe = new TicketPipe();
getProgressLevel() : string{
  return this.ticketPipe.transform(this.ticket, 'progressLevel');
}
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
getAddress(partner : Partner) {
  if (! partner) return "";
  let address = "";
  if (partner.streetName1)  address += partner.streetName1 + " ";
  if (partner.streetName2)  address += partner.streetName2 + " ";
  if (partner.city)         address += partner.city + " ";
  return address;
}
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
sameBranch(partnerBranch : Branch, ticketBranch : Branch) : boolean{
  if ((!partnerBranch) && (!ticketBranch)) return true;
  if (( partnerBranch) && (!ticketBranch)) return false;
  if ((!partnerBranch) && ( ticketBranch)) return false;
  return (partnerBranch.name == ticketBranch.name);
}
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
checkData(): boolean{
  if ( (! this.ticket.creationComment) ||  (! this.ticket.creationComment.trim())) {
    this.showError("La description de problème à régler doit être renseignée");
    return false;
  }
  if (! this.ticket.ticketType) {
    this.showError("Le type du ticket doit être renseignée");
    return false;
  }
  if (this.ticket.progressLevel == TicketPL.pl_qualified) {
    if ( (! this.ticket.qualificationComment) ||  (! this.ticket.qualificationComment.trim())) {
      this.showError("La qualification du ticket doit être renseignée");
      return false;
    }
  }
  if (this.ticket.progressLevel == TicketPL.pl_closed) {
    if ( (! this.ticket.closingComment) ||  (! this.ticket.closingComment.trim())) {
      this.showError("La commentaire de clôture du ticket doit être renseignée");
      return false;
    }
  }
  return true;
}
//---------------------------------------------------------------------------------------
 



  loadDocument(tbt : TicketBatchTicket, input : any){
    let files: FileList = input.files ? input.files : input.srcElement.files; 
    this.getBase64(files[0]).then( result =>{
      tbt.document = result;
      input.value = "";

      this.ticketService.documentSave(tbt);
      this.showDocument(tbt);
    })
  }



  pdfToShow : string;
  showDocument(tbt : TicketBatchTicket){
    this.pdfToShow = tbt.document; 
  }


  getBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
  }

  printDocument(){
    this.salesReportsService.ticketOrderPrint(this.ticket.id)
  }
}
